import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { EmpresaCnpjWs, InscricaoEstadual } from 'src/app/models/Empresa/EmpresaCnpjWs.model';

const CNPJ_WS_BASE_URL = 'https://publica.cnpj.ws';

@Injectable({
    providedIn: 'root'
})
export class CnpjWsService {

    constructor(private http: HttpClient) { }

    public async consultarCnpj(cnpj: string): Promise<EmpresaCnpjWs | null> {
        try {
            const response: any = await firstValueFrom(
                this.http.get(`${CNPJ_WS_BASE_URL}/cnpj/${cnpj}`)
            );

            const estabelecimento = response?.estabelecimento;

            const inscricoesEstaduais: InscricaoEstadual[] = (estabelecimento?.inscricoes_estaduais ?? [])
                .map((ie: any) => ({
                    numero: ie?.inscricao_estadual,
                    uf: ie?.estado?.sigla
                }));

            return {
                razaoSocial: response?.razao_social,
                nomeFantasia: estabelecimento?.nome_fantasia ?? null,
                cep: estabelecimento?.cep,
                estado: estabelecimento?.estado?.sigla ?? null,
                inscricoesEstaduais
            };
        } catch {
            return null;
        }
    }
}
